import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'
import FONTS from 'constants/fonts'

export const Wrap = styled.div`
  margin: ${LAYOUT.VERTICALSPACEMOBILE} 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  max-width: 980px;
  ${MEDIA.medium`
  margin: ${LAYOUT.VERTICALSPACEMOBILE} auto ${LAYOUT.VERTICALSPACE} ;
  `}
`

export const Item = styled.div`
  margin: 10px 20px;
  text-align: center;
  ${MEDIA.medium`
    min-height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin: 10px 15px;
  `}
`

export const Title = styled.span`
  text-align: center;
  max-width: 160px;
  margin: auto;
  display: block;
  font-size: ${FONTS.FONTLARGE};
  margin-top: 20px;
`
